export { default as Mail } from './mail.svg'
export { default as Warning } from './warning.svg'
